import { useCallback } from 'react';
import { DanelEmptyStateProps } from './types';

export const useDanelEmptyState = (props: DanelEmptyStateProps) => {
  const { onUploadExcel, onUploadKasefet, disabled = false } = props;

  const handleUploadExcel = useCallback(() => {
    if (onUploadExcel) {
      onUploadExcel();
    }
  }, [onUploadExcel]);

  const handleUploadKasefet = useCallback(() => {
    if (onUploadKasefet) {
      onUploadKasefet();
    }
  }, [onUploadKasefet]);

  const isDisabled = disabled;

  return {
    isDisabled,
    handleUploadExcel,
    handleUploadKasefet,
  };
};
